module.exports = __webpack_public_path__ + "static/social-proof-2c03b526600f8edf3907482d4e20e258.png";